import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { 
  LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_RELEVANT_POP_UP, 
  SOURCE_NAME_TWITTER,
  CANCEL_BUTTON_TEXT,
  CONFIRM_BUTTON_TEXT,
  CANCEL_BUTTON_COLOR,
  CONFIRM_BUTTON_COLOR,
  TWEET_TEXT,
  COMMENT_TEXT 
} from '../../redux/constants';


const IRRELEVANT = 'irrelevant';
const RELEVANT = 'relevant';
const MySweetAlertGenerator = withReactContent(Swal);

export class RelevanceCard extends Component {
static propTypes = {
    userCommentOrPost: PropTypes.object.isRequired,
    updateRelevance: PropTypes.func.isRequired,
    commentOrPostId: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      userCommentOrPost: this.props.userCommentOrPost,
      updateRelevance: this.props.updateRelevance,
      relevancePlaceholder: this.props.userCommentOrPost.relevance ? IRRELEVANT : RELEVANT,
      isRelevant: this.props.userCommentOrPost.relevance,
      commentOrPostId: this.props.commentOrPostId,
      source: this.props.userCommentOrPost.source.toLowerCase(),
      isRelevanceButtonDisabled: this.props.isRelevanceButtonDisabled
    };
  }


  componentDidMount() {
    const userCommentOrPost = this.props.userCommentOrPost; 
    const updateRelevance = this.props.updateRelevance;
    const commentOrPostId = this.props.commentOrPostId;
    this.setState({
      userCommentOrPost: userCommentOrPost,
      updateRelevance: updateRelevance,
      isRelevant: userCommentOrPost.relevance,
      commentOrPostId: commentOrPostId
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.userCommentOrPost.relevance !== this.props.userCommentOrPost.relevance) {
      this.setState({
        userCommentOrPost: nextProps.userCommentOrPost,
        commentOrPostId: nextProps.commentOrPostId,
        isRelevant: nextProps.userCommentOrPost.relevance,
        relevancePlaceholder: this.props.userCommentOrPost.relevance ? IRRELEVANT : RELEVANT,
        source: this.props.userCommentOrPost.source.toLowerCase()
      });
    }
  }

  setRelevanceActionButton() {
    const { isRelevanceButtonDisabled } = this.state;
    if (!isRelevanceButtonDisabled){
      if (this._hasCheckedDoNotShowRelevancePopUpMessage()) {
        this.setRelevance();
      } 
      else { 
        this.setRelevanceActionButtonWithPopUpMessage();
      }
    }
  }

  setRelevanceActionButtonWithPopUpMessage() {
    const { isRelevant, source } = this.state;
    MySweetAlertGenerator.fire({
      html: `<h5><b>Mark as ${!isRelevant ? RELEVANT : IRRELEVANT}</b></h5><br/>
              <p>You are about to mark this ${source === SOURCE_NAME_TWITTER ? TWEET_TEXT : COMMENT_TEXT} as <span class="bolded">${!isRelevant ? RELEVANT : IRRELEVANT}</span>. 
              Would you like to proceed?</p>`,
      input: 'checkbox',
      inputPlaceholder: 'Do not show this message again',
      showCancelButton: true,
      confirmButtonColor: CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CANCEL_BUTTON_COLOR,
      cancelButtonText: CANCEL_BUTTON_TEXT,
      confirmButtonText: CONFIRM_BUTTON_TEXT,
      showCloseButton: true,
      reverseButtons: true,
    }).then(result => {
      if (result.value === 0) {
        this.setRelevance();
      }

      if (result.value === 1) {
        this._setDoNotShowRelevancePopUpMessage();
        this.setRelevance();
      }
    })
  }

  setRelevance() {
    const { isRelevant, userCommentOrPost, updateRelevance, commentOrPostId } = this.state;

    if (userCommentOrPost.relevance === isRelevant) {
      updateRelevance({ commentOrPostId, relevance: !isRelevant });
    }
  }

  _setDoNotShowRelevancePopUpMessage() {
    localStorage.setItem(LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_RELEVANT_POP_UP, "true");
  }

  _hasCheckedDoNotShowRelevancePopUpMessage () {
    return localStorage.getItem(LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_RELEVANT_POP_UP);
  }


  render() {
    const {
      relevancePlaceholder,
      isRelevanceButtonDisabled
    } = this.state;

    return ( 
      <div
        className={isRelevanceButtonDisabled ? "card-header-relevance-edit-disabled": "card-header-relevance"}
        onClick={() => this.setRelevanceActionButton()}
      >
        <div className='relevance-placeholder'>Mark as {relevancePlaceholder}</div>
      </div>
    )
  }
}

export default RelevanceCard;


// WEBPACK FOOTER //
// ./src/features/home/components/comment-toggle/RelevanceCard.js